import React from 'react'
// import AdobeLogo from "../assets/download.png";
import adobePlaceholder from '../../src/assets/adobePlaceholder.png'

import '../styles/Footer.scss'
const Footer = () => {
	return (
		<footer color="elegant-color-dark" className="font-small footer">
			<div className="footer-copyright text-center py-3">
				<img className="logoFooter" src={adobePlaceholder} alt="" />

				<p className="copyright">
					Copyright © 2019 Adobe. All rights reserved.
				</p>
			</div>
		</footer>
	)
}

export default Footer
